import { render, staticRenderFns } from "./TableEmployees.vue?vue&type=template&id=37da7275&"
import script from "./TableEmployees.vue?vue&type=script&lang=js&"
export * from "./TableEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QList,QItem,QItemSection,QField,QItemLabel,QTr,QTh,QTd,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QList,QItem,QItemSection,QField,QItemLabel,QTr,QTh,QTd,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
